import script from "./ModeratorRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeratorRequestForm.vue?vue&type=script&setup=true&lang=js"

import "./ModeratorRequestForm.vue?vue&type=style&index=0&id=58d1a028&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58d1a028"]])

export default __exports__